<template>
    <span
        class="text-danger float-left mr-1"
        v-if="convenio.idSituacaoConvenio != 9">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir Licitação"
            @click.stop="confirmarExcluir(licitacao.idLicitacao)"
        ></i>
    </span>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {
    props: {
        convenio: Object,
        licitacao: Object
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir(id) {
            this.$swal({
                title: 'Excluir',
                html:'Deseja Excluir a Licitação?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir(id)
                }
            })
        },

        excluir(id) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.excluirLicitacao(id).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Licitação excluída com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarLista')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },
    }
}
</script>
